<template>
    <div>
        <button @click="open"
                 class="mt-2  py-1 px-2 border border-gray-300 shadow-sm text-sm rounded-md text-gray-700 font-medium hover:bg-gray-100">
                 <i class="fa fa-trash-o" aria-hidden="true"></i>
            Delete
        </button>

        <portal to="modal" v-if="showModal">
            <modal @close="showModal = false">

                <p>Möchtest du die Gruppe <span class="font-bold">{{ group.name }}</span> wirklich löschen?</p>

                <input class="border p-4 rounded" type="text" v-model="del">

                <p>Schreib "delete" in das Feld und drücke löschen.</p>

                <button class="mt-4 px-4 py-2 rounded border border-red-500 bg-red-200" @click="confirm">Löschen</button>
            </modal>
        </portal>
    </div>
</template>

<script>
    import Modal from "../Modal";

    export default {
        name: "DeleteGroup",
        components: {Modal},
        props: ['group'],
        data: () => ({
            showModal: false,
            del: '',
        }),

        methods: {
            open() {
                this.showModal = true;
                this.del = '';
            },
            confirm() {
                if (this.del !== 'delete') {
                    return;
                }

                window.axios
                    .post(`/super/groups/${this.group.id}`, {
                        _method: 'delete',
                    })
                    .then(function (response) {
                        location.reload();
                    })
                    .catch(error => {
                        this.$root.$emit('error', error);
                    });
            }
        }
    }
</script>

<style scoped>

</style>
